<template>
  <div>
    <div class="api-tips">
      备注：若需调用API，可在此处配置白名单IP。
    </div>
    <div class="ips">
      <el-form :model="form" ref="form" :rules="rules">
        <el-form-item label="IP:" prop="ip" label-width="60px"> 
          <el-input v-model="form.ip" autocomplete="off" style="width: 400px" placeholder='请输入IP，如需输入多个ip，请以逗号分隔'></el-input>
        </el-form-item>
        <el-form-item label-width="60px">
          <el-button type="primary" @click="saveInfo()">提交数据</el-button>
        </el-form-item>
      </el-form>
      
    </div>
  </div>
</template>
<script>
import { platformIp } from "@/api/api.js";
import { getPlatformIp } from "@/api/api.js";
export default {
  data() {
    return{
      userId:'',
      form:{
        ip:""
      },
      rules:{
        ip:[
          { required: true, message: "请输入IP", trigger: "blur" }
        ],
      } 
    }
  },
  methods: {
    // 获取列表的数据
    initData(){
      let params = {
        userId : this.userId
      };
      getPlatformIp(params).then(res=>{
        this.form.ip = res.data.data
      })
    },
    saveInfo(){
      this.$refs.form.validate(valid => {
        if (valid) {
          let formData = new FormData();
          formData.append("ip", this.form.ip);
          formData.append("userId",this.userId);
          let config = {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          };
          platformIp(formData,config).then(res=>{
            if(res.data.code == 200){
              this.$notify({
                title: '成功',
                message: '信息提交成功',
                type: 'success'
              });
            }else{
              this.$message.error(res.data.message);
            }
          })
        }
      })
    },
    clearCheck(){
      this.$refs.form.clearValidate();
    }
  },
  mounted() {

  },
  created() {
    this.userId = this.$route.params && this.$route.params.userId;
  }
};
</script>

<style scoped lang="less">
.api-tips{
  border: 1px solid #f7e794;
  background: #fcf4ca;
  padding: 5px;
  font-size: 14px;
  text-indent: 5px;
}
.ips{
  margin-top: 20px;
}
</style>


